/* tslint:disable */
 
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Authentication type enumeration representing different authentication flows supported by the system
 * @export
 */
export const AuthType = {
    CognitoEmbedEmailPassword: 'COGNITO_EMBED_EMAIL_PASSWORD',
    CognitoManagedEmailPassword: 'COGNITO_MANAGED_EMAIL_PASSWORD',
    CognitoSso: 'COGNITO_SSO'
} as const;
export type AuthType = typeof AuthType[keyof typeof AuthType];


export function instanceOfAuthType(value: any): boolean {
    for (const key in AuthType) {
        if (Object.prototype.hasOwnProperty.call(AuthType, key)) {
            if (AuthType[key as keyof typeof AuthType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuthTypeFromJSON(json: any): AuthType {
    return AuthTypeFromJSONTyped(json, false);
}

export function AuthTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthType {
    return json as AuthType;
}

export function AuthTypeToJSON(value?: AuthType | null): any {
    return value as any;
}

export function AuthTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AuthType {
    return value as AuthType;
}

